export default function Pill({ status, statusText }) {
  return (
    <div className={`ui-badge-pill ui-badge-pill-${status}`}>{statusText}</div>
  );
}
